export interface PostRequestPayload {
  coachId: string;
  paymentMethodId: string;
  amount: number;
}

export const PREMIUM_SUBSCRIBE_API = `v1/premium/subscribe`;
